module.exports = __webpack_public_path__ + "img/locator-sharow-left.3376a17.png";